import { render } from "./EditActivityModal.vue?vue&type=template&id=3c7b8fb8"
import script from "./EditActivityModal.vue?vue&type=script&lang=js"
export * from "./EditActivityModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__